import styled from "@emotion/styled";

export const RecruitingListContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
`;

export const RecruitingListWrapper = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    gap: 2rem;
    overflow: hidden;
    padding: 1rem;
`;
